<template>
  <a-drawer width="800" placement="right" :visible="visible" @close="onClose">
    <h3 class="drawer-title">
      Waarderingen bewerken
    </h3>
    <a-row type="flex" :gutter="16" v-for="valuation in valuations" :key="valuation.id"
           style="border-bottom: solid 1px #ccc; margin-bottom: 15px;">
      <a-col flex="auto">
        <PropertyValuationEditComponent
            :valuation="valuation"
        />
      </a-col>
      <a-col style="padding-top: 32px;">
        <a-button type="danger" v-on:click="deletePropertyValuation(valuation)">
          <delete-icon></delete-icon>
        </a-button>
      </a-col>
    </a-row>

    <a-button type="primary" v-on:click="addPropertyValuation">
      Waardering toevoegen
      <plus-icon></plus-icon>
    </a-button>
    <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
    >
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        Cancel
      </a-button>
      <a-button type="primary" @click="onSubmit">
        Submit
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import moment from 'moment';
import propertyValuationApi from '~/api/property_valuation';
import PropertyValuationEditComponent from '~/modules/property_valuation/components/EditComponent';
import {DateFormatEnum} from "../../../enums";

export default {
  name: "PropertyValuationEditDrawerComponent",
  components: {
    PropertyValuationEditComponent,
  },
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valuations: [],
      visible: false,
    };
  },
  mounted() {
    if (!this.property.valuations || !this.property.valuations.data) {
      propertyValuationApi.paginateByProperty(this.property.id).then(response => {
        this.valuations = response.data;
      });
    } else {
      this.valuations = this.property.valuations.data;
    }
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onSubmit() {
      Promise.all(this.valuations.map(valuation => {
        return (typeof valuation.id === "undefined")
          ? propertyValuationApi.create(valuation)
          : propertyValuationApi.update(valuation);
      })).then(() => {
        this.visible = false;
        this.$set(this.property.valuations, 'data', this.valuations);
      }).catch(errors => {
        this.$message.error('Er ging iets mis tijdens het bijwerken van de waarderingen, controleer de velden.');
      });
    },
    onClose() {
      this.visible = false;
    },
    addPropertyValuation() {
      this.valuations.push({
        property_id: this.property.id,
        registration_date: moment().format(DateFormatEnum.ISO8601)
      });
    },
    deletePropertyValuation(valuation) {
      if (typeof valuation.id === "undefined") {
        this.valuations.splice(this.valuations.indexOf(valuation), 1);
      } else {
        propertyValuationApi.delete(valuation.id).then(() => {
          this.$set(this, 'valuations', this.valuations.filter(item => item.id !== valuation.id));
          this.$set(this.property.valuations, 'data', this.valuations);
        });
      }
    }
  },
};
</script>
<style scoped>
.drawer-title {
  margin-bottom: 30px;
}
.pull-right {
  float: right;
}
</style>